import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import ReCAPTCHA from 'react-google-recaptcha'

import Panel from '@/components/Panel/Panel'
import Spinner from '@/components/Spinner/Spinner'
import { recaptchaKey } from '@/utils/constants'
import useMail from '@/utils/useMail'

type Props = {
  description: React.ReactNode
  destination: string
}

const Mail = ({ description, destination }: Props) => {
  const {
    desc,
    email,
    errors,
    fileInput,
    isPosting,
    onCaptcha,
    onChangeDesc,
    onChangeEmail,
    onFileChosen,
    onSubmit,
    success,
  } = useMail()

  return (
    <Panel>
      {description}
      <form
        className='d-grid gap-3 pb-3'
        onSubmit={(e) => {
          e.preventDefault()
          onSubmit(destination)
        }}
      >
        <div>
          <Form.Label>Email</Form.Label>
          <Form.Control onChange={onChangeEmail} placeholder='Email' required type='email' value={email} />
          {errors.email && <p className='form-text text-danger'>{errors.email}</p>}
        </div>
        <div>
          <Form.Label>Message</Form.Label>
          <Form.Control as='textarea' onChange={onChangeDesc} placeholder='Message' required rows={5} value={desc} />
          {errors.desc && <p className='form-text text-danger'>{errors.desc}</p>}
        </div>
        <div>
          <Form.Label>Attachment (optional)</Form.Label>
          <div>
            <input onChange={onFileChosen} ref={fileInput} type='file' />
          </div>
          {errors.file && <p className='form-text text-danger'>{errors.file}</p>}
        </div>
        <div>
          <Form.Label>Captcha</Form.Label>
          <ReCAPTCHA onChange={onCaptcha} sitekey={recaptchaKey} />
          {errors.captcha && <p className='form-text text-danger'>{errors.captcha}</p>}
        </div>
        <Button disabled={isPosting || success.length > 0} type='submit'>
          {isPosting ? <Spinner /> : success.length > 0 ? 'Done' : 'Submit'}
        </Button>
        {errors.submit && <Alert variant='danger'>{errors.submit}</Alert>}
        {success && <Alert variant='success'>{success}</Alert>}
      </form>
    </Panel>
  )
}

export default Mail
